import {Component, Input, OnInit, inject} from '@angular/core';
import {Router} from '@angular/router';
import {MenuItem} from '../navigation/menu-items';
import {MenuBase} from '../menu-base/menu-base.component';
import {GoogleTagManagerService} from 'angular-google-tag-manager';
import {TrackingService} from '../../../../services/tracking.service';
import {AmplitudeService} from '../../../../services/amplitude.service';
import {PermissionGuardDirective} from '../../../../common/directives/permission-guard.directive';
import {ExpansionPanelNavItemComponent} from '../../../dumb/expansion-panel-nav-item/expansion-panel-nav-item.component';
import {NgClass} from '@angular/common';
import {NavItemComponent} from '../../../dumb/nav-item/nav-item.component';
import {WalkThroughStepDirective} from '../../../../modules/walkthrough/walkthough-step/walkthrough-step.directive';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  standalone: true,
  selector: 'mc-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.scss'],
  imports: [
    PermissionGuardDirective,
    ExpansionPanelNavItemComponent,
    NgClass,
    NavItemComponent,
    WalkThroughStepDirective,
    TranslatePipe,
  ],
})
export class NavMenuComponent extends MenuBase implements OnInit {
  protected readonly router: Router;
  protected readonly gtmService: GoogleTagManagerService;
  protected readonly trackingService: TrackingService;
  protected readonly ampliService: AmplitudeService;

  public menuItemsList: MenuItem[] = [];

  constructor() {
    const router = inject(Router);
    const gtmService = inject(GoogleTagManagerService);
    const trackingService = inject(TrackingService);
    const ampliService = inject(AmplitudeService);

    super(router, gtmService, trackingService, ampliService);

    this.router = router;
    this.gtmService = gtmService;
    this.trackingService = trackingService;
    this.ampliService = ampliService;
  }

  @Input() set menuItems(value: MenuItem[]) {
    this.menuItemsList = value;
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  goToMenuItem(item: MenuItem) {
    this.router.navigate([item.routerLink]);
  }

  isActiveNavLink(menuItem: MenuItem): boolean {
    return (
      this.router.isActive(menuItem.routerLink, {
        paths: 'subset',
        queryParams: 'subset',
        fragment: 'ignored',
        matrixParams: 'ignored',
      }) || !!menuItem.menuItems?.find(({routerLink}) => this.currentRoute.startsWith(routerLink))
    );
  }
}
